<script setup lang="ts">
import { StoreOrderSubstatus } from '~/lib/models/order'
import { StoreOrder } from '~/lib/services/store/order/order.dto'

const props = defineProps<{
  order: StoreOrder
}>()
const { t } = useLocale()
const { format, formatNumber } = useFormatAmount()

const refundMoney = computed(() => {
  return (
    props.order.subStatus === StoreOrderSubstatus.PARTIAL_REFUNDED_ALL ||
    props.order.subStatus === StoreOrderSubstatus.PARTIAL_REFUNDED_MONEY ||
    props.order.subStatus === StoreOrderSubstatus.TOTAL_REFUNDED_ALL ||
    props.order.subStatus === StoreOrderSubstatus.TOTAL_REFUNDED_MONEY
  )
})

const refundPoints = computed(() => {
  return (
    props.order.subStatus === StoreOrderSubstatus.PARTIAL_REFUNDED_ALL ||
    props.order.subStatus === StoreOrderSubstatus.PARTIAL_REFUNDED_LOYALTY ||
    props.order.subStatus === StoreOrderSubstatus.TOTAL_REFUNDED_ALL ||
    props.order.subStatus === StoreOrderSubstatus.TOTAL_REFUNDED_LOYALTY
  )
})

const refundedMoneyAmount = computed(() => {
  if (
    props.order.subStatus === StoreOrderSubstatus.TOTAL_REFUNDED_ALL ||
    props.order.subStatus === StoreOrderSubstatus.TOTAL_REFUNDED_MONEY
  ) {
    return props.order.refund?.money ?? 0
  }

  return (
    props.order.products.reduce((acc, product) => {
      return acc + (product.refund?.money || 0)
    }, 0) ?? 0
  )
})

const refundedPointsAmount = computed(() => {
  if (
    props.order.subStatus === StoreOrderSubstatus.TOTAL_REFUNDED_ALL ||
    props.order.subStatus === StoreOrderSubstatus.TOTAL_REFUNDED_LOYALTY
  ) {
    return props.order.refund?.points ?? 0
  }

  return (
    props.order.products.reduce((acc, product) => {
      return acc + (product.refund?.points || 0)
    }, 0) ?? 0
  )
})
</script>

<template>
  <div class="flex flex-col gap-2">
    <div
      v-if="refundMoney"
      data-test="cart-amount-row-money-refund"
      class="flex flex-row items-center justify-between text-sm text-mcd-secondaryDarkGrey"
    >
      <p class="max-w-[60%] truncate">
        {{ t('shoppingCart.moneyRefund') }}
      </p>
      <span class="block">- {{ format(refundedMoneyAmount) }}</span>
    </div>

    <div
      v-if="refundPoints"
      data-test="cart-amount-row-points-refund"
      class="flex flex-row items-center justify-between text-sm text-mcd-secondaryDarkGrey"
    >
      <p class="max-w-[60%] truncate">
        {{ t('shoppingCart.pointsRefund') }}
      </p>
      <span class="inline-flex items-center gap-2">
        <img src="/images/icons/coin-transparent.svg" alt="locateMe" />
        +{{ formatNumber(refundedPointsAmount) }} pts.
      </span>
    </div>
  </div>
</template>
